import { VideoUpload } from '../../../../components'

interface Props {
  onChange: (file: File, size?: { w: number | null; h: number | null }) => void
  loading: boolean
  uploadProgress: number
  previewUrl: string | null
  error: string | null
}

export const SetInspirationVideo = ({
  onChange,
  loading,
  uploadProgress,
  previewUrl,
  error,
}: Props) => {
  return (
    <div>
      <div className='mt-10 sm:mt-0'>
        <div className='md:grid md:grid-cols-3 md:gap-6'>
          <div className='md:col-span-1'>
            <div className=''>
              <h3 className='text-lg font-semibold font-sans leading-6 text-gray-900'>
                Video
              </h3>
              <p className='mt-1 text-sm font-normal leading-5 text-gray-500 font-sans'>
                Upload your video.
              </p>
            </div>
          </div>
          <div className='mt-5 md:col-span-2 md:mt-0'>
            <div className='md:shadow rounded-t-md sm:overflow-hidden'>
              <div className='py-5 md:bg-white space-y-6 sm:p-6'>
                <div className='grid gap-6'>
                  <div className='col-span-3 sm:col-span-2'>
                    {loading && previewUrl && (
                      <div className='flex flex-col justify-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6'>
                        <div className='mb-4 flex mx-auto'>
                          <video
                            className='max-h-[350px]'
                            src={previewUrl}
                            controls
                          />
                        </div>
                      </div>
                    )}
                    {!loading && <VideoUpload onChange={onChange} />}
                    {error && (
                      <p className='text-sm text-red-500 mt-2'>
                        Please upload a video.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='hidden sm:block' aria-hidden='true'>
        <div className='py-5'>
          <div className='border-t border-gray-200' />
        </div>
      </div>
    </div>
  )
}
